import React from "react";
import { ExternalProps } from "./AddressTypeahead";
import { FourPartAddress } from "./FourPartAddress";
import { addressParse, AddressSegments, defaultAddressSegments, addressJoin } from "./segments";
import { AddressTypeaheadEquifax } from "./AddressTypeaheadEquifax";

interface Props extends ExternalProps {

}

interface State {
  isCustom: boolean;
  customAddress: AddressSegments | null;
  initialValue?: string;
  currentValue: string;
  isParsing: boolean;
}

export class AddressTypeaheadEquifaxWithFallback extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      isCustom: false,
      customAddress: null,
      initialValue: props.initialValue,
      currentValue: props.initialValue || '',
      isParsing: false,
    }
  }

  setParsedCustomAddress = (parsedAddress: AddressSegments) => {

    const joinedAddress = addressJoin(parsedAddress);
    this.setState({
      ...this.state, 
      isCustom: true,
      customAddress: parsedAddress, 
      currentValue: joinedAddress,
      isParsing: false,
    });
    if (this.props.onInputChange) {
      this.props.onInputChange(joinedAddress, true);
    }

  };

  setDefaultCustomAddress = () => {

      this.setState({
        ...this.state, 
        isCustom: true,
        customAddress: defaultAddressSegments,
        currentValue: "",
        isParsing: false,
      });
      if (this.props.onInputChange) {
        this.props.onInputChange(addressJoin(defaultAddressSegments), true);
      }

  };

  _handleInputChange = (value: string, isCustom: boolean) => {
    const newState = {...this.state, currentValue: value};
    this.setState(newState);

    if (this.props.onInputChange) this.props.onInputChange(value, isCustom);
    if (this.state.isCustom !== isCustom) {
      newState.isCustom = isCustom;
      newState.customAddress = null;
      this.setState(newState);
      if (isCustom) {
        this.setState({...this.state, isParsing: true}, () => {
          addressParse(value)
          .then(parsedAddress => this.setParsedCustomAddress(parsedAddress))
          .catch(e => this.setDefaultCustomAddress());
        });

      }
    }
  };

  _handleCustomToggle = () => {
    this.setState({...this.state, isCustom: false, customAddress: null, initialValue: undefined, currentValue: ""});
    if (this.props.onInputChange) this.props.onInputChange('', false);
  };

  _handleCustomAddressChange = (value: AddressSegments) => {
    const joinedAddress = addressJoin(value);
    this.setState({...this.state, customAddress: value, currentValue: joinedAddress});
    if (this.props.onInputChange) {
      this.props.onInputChange(joinedAddress, true);
    }
  };

  _handleBlur = () => {
    const val = this.state.currentValue.trim();
    if (val.length > 0) {
      this.setState({...this.state, isParsing: true}, () => {
        addressParse(val).then(parsedAddress => {
          if (!parsedAddress.valid) {
            this.setParsedCustomAddress(parsedAddress);
          }
        }).catch(e => this.setDefaultCustomAddress());
      });
    }
  };

  render() {

    const {onInputChange, initialValue, ...passThroughProps} = this.props;

    return (
      <div className={`polygon-address-typeahead reactjs-validation ${this.state.isParsing ? 'is-parsing': ''}`}>
        {this.state.isCustom ?
          <React.Fragment>

            {/* <input readOnly className="form-control" value={this.state.customAddress ? addressJoin(this.state.customAddress) : 'Loading...'}/> */}
            <div className="row">
              <div className="col-md-12">
              <div className="checkbox">
                  <label>
                    <input type="checkbox" checked={true} onChange={this._handleCustomToggle}/>
                    Manually enter address
                  </label>
              </div>
              </div>
            </div>
            {this.state.customAddress ?
              <FourPartAddress 
                value={this.state.customAddress} 
                onChange={this._handleCustomAddressChange}
                name={this.props.name}
              />
              :
              <div>Loading...</div>
            }
          </React.Fragment>
          :
          <>
            <AddressTypeaheadEquifax 
              onInputChange={this._handleInputChange}
              onBlur={this._handleBlur} 
              initialValue={this.state.initialValue}
              // initialValue={this.state.customAddress ? addressJoin(this.state.customAddress) : undefined}
              {...passThroughProps}
            />
            {this.state.isParsing && <span className="label label-danger">Please wait while parsing address</span>}
          </>
        }

      </div>
    );

  }
}